import { create } from "zustand";
import axios from "axios";

const orderDeliveryStatusTimeStore = create((set) => ({
  orderDeliveryStatusTime: null,
  isLoading: true,

  fetchAllOrderDeliveryStatusTime: async () => {
    const res = await axios.get("/fetch-all-user-order-delivery-status-time");

    if (res.data.orderDeliveryStatusTime.length) {
      set({ orderDeliveryStatusTime: res.data.orderDeliveryStatusTime });
    }
    set({ isLoading: false });
  },

  updateOrderDeliveryStatusTime: async ({
    _id,
    preparing,
    in_transit,
    out_of_delivery,
    delivered,
    returning,
    cancelled,
  }) => {
    try {
      set({ isLoading: true });
      const res = await axios.put(`/update-order-delivery-status-time/${_id}`, {
        preparing,
        in_transit,
        out_of_delivery,
        delivered,
        returning,
        cancelled,
      });

      // update state
      const { orderDeliveryStatusTime } =
        orderDeliveryStatusTimeStore.getState();
      const newState = [...orderDeliveryStatusTime];
      const indexState = orderDeliveryStatusTime.findIndex((s) => {
        return s._id === _id;
      });
      newState[indexState] = res.data.orderDeliveryStatusTime;

      set({ orderDeliveryStatusTime: newState });
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
      set({ isLoading: false });
    }
  },

  createOrderDeliveryStatusTimeForReturn: async ({
    createOrderDeliveryStatusTimeData,
  }) => {
    try {
      const res = await axios.post(
        "/create-order-delivery-status-time-for-return",
        createOrderDeliveryStatusTimeData
      );

      if (res) {
        const { orderDeliveryStatusTime } =
          orderDeliveryStatusTimeStore.getState();

        const data = [...orderDeliveryStatusTime];
        data.push(res.data.orderDeliveryStatusTime);

        return res.data.orderDeliveryStatusTime._id;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  },
}));

export default orderDeliveryStatusTimeStore;
